
import Vue, { PropType } from 'vue'
import { Breadcrumb } from '@/types'
/**
 * Компонент хлебных крошек
 * @param pages - массив страниц
 */
export default Vue.extend({
  props: {
    pages: {
      type: Array as PropType<Array<Breadcrumb>>,
      required: true
    }
  }
})
